import React, { useState } from "react";
import ETH from "../../../assets/images/ETH1.svg";
import btc from "../../../assets/images/bitcoinLogo.svg";
import style from "./allowSwap.module.scss";
import Modal from "../popup/popup";
import ModalStyle from "../ModalStyles/ModalStyle";
import DropDown from "../../_Common/DropDown/dropDown";

function AllowSwap() {
  const [popupVisible, setPopupVisible] = useState(false);
  const togglePopup = (e) => {
    e.preventDefault();
    setPopupVisible((prev) => !prev);
  };
  const [selected, setSelected] = useState("BTC");
  const options = ["BTC", "USDa", "LITE", "ETH"];
  const [selected2, setSelected2] = useState("BTC");
  const Bitcoin = ["BTC", "USDa", "LITE", "ETH"];
  return (
    <>
      <Modal visible={popupVisible} onClose={() => setPopupVisible(false)}>
        <ModalStyle />
      </Modal>
      <div className={style.container}>
        <div className={style.Wrapper}>
          <div className={style.SubWrapper}>
            <div className={style.HeadingWrapper}>
              <div className={style.subHeadingWrapper}>
                <img src={btc} alt="btc" />
                <div className={style.Heading}>Bitcoin</div>
              </div>

              <div className={style.NavWrapper}>
                <div className={style.DropDown}>
                  <DropDown
                    padding="13px 8px"
                    grow="100%"
                    selected={selected2}
                    setSelected={setSelected2}
                    options={Bitcoin}
                    // imgShow={true}
                  />
                </div>

                <input type="number" placeholder="0.0" />
              </div>
            </div>
            <div className={style.subContainer}>
              <div className={style.HeadingWrapper2}>
                <div className={style.subHeadingWrapper2}>
                  <img src={ETH} alt="Eth" />
                  <div className={style.Heading}>Ethereum</div>
                </div>
                <div className={style.NavWrapper2}>
                  <form action="/">
                    <div className={style.NavWrapper}>
                      <div className={style.DropDown}>
                        <DropDown
                          padding="13px 8px"
                          grow="100%"
                          selected={selected}
                          setSelected={setSelected}
                          options={options}
                          // imgShow={true}
                        />
                      </div>

                      <input type="number" placeholder="0.0" />
                    </div>
                    <div className={style.bottomtextsize}>
                      <div className={style.bottomtext}>Balance: 0 ETH</div>
                      <div className={style.bottomtext2}>LP Fee: 0.001 ETH</div>
                      <div className={style.bottomtext2}>
                        Crosschain Fee: 0.001 ETH
                      </div>
                    </div>
                    <button type="submit" value="Submit" onClick={togglePopup}>
                      Allow to Swap
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AllowSwap;
